<style scoped> 
    @import "../assets/css/settings.css";
</style>
<template>
    <div id="settings">
        <div class='container-fluid px-0 settings_container' :style="{left : !$store.state.menu_toggle ? '70px' : '255px'}">
            <div class="row m-16">
                <div class="col-12">
                    <h3 class="m-0">General</h3>
                </div>
                <div class="col-12">
                    <div class="row">
                        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                            <a :href="this.url+'stores/view_my_stores'">
                                <div class="card mt-4">
                                    <div class="row card-body">
                                        <div class="align-self-center setting_icon_div px-2">
                                            <img width="64" height="64" src="../assets/images/salon_setting.svg">
                                        </div>
                                        <div class="content_div">
                                            <h5><b>Salons</b></h5>
                                            <p class="m-0 ash font-14 content_text">Manage all of your salon’s details like email, phone and address.</p>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                            <a :href="this.url+'workinghrs/'">
                                <div class="card mt-4">
                                    <div class="row card-body">
                                        <div class="align-self-center setting_icon_div px-2">
                                            <img width="64" height="64" src="../assets/images/salon_hour_setting.svg">
                                        </div>
                                        <div class="content_div">
                                            <h5><b>Salon Hours</b></h5>
                                            <p class="m-0 ash font-14 content_text">Manage the salon working hours according to your choice of time slots.</p>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                            <a :href="this.url+'category/view_service_category'">
                                <div class="card mt-4">
                                    <div class="row card-body">
                                        <div class="align-self-center setting_icon_div px-2">
                                            <img width="64" height="64" src="../assets/images/service_cat_setting.svg">
                                        </div>
                                        <div class="content_div">
                                            <h5><b>Service Categories</b></h5>
                                            <p class="m-0 ash font-14 content_text">Manage all service categories details with the respective salon.</p>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                            <a :href="this.url+'services/view_my_services'">
                                <div class="card mt-4">
                                    <div class="row card-body">
                                        <div class="align-self-center setting_icon_div px-2">
                                            <img width="64" height="64" src="../assets/images/services_setting.svg">
                                        </div>
                                        <div class="content_div">
                                            <h5><b>Services</b></h5>
                                            <p class="m-0 ash font-14 content_text">Manage all services along with their price, status with the respective salon.</p>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                            <a :href="this.url+'staff/view_my_staff'">
                                <div class="card mt-4">
                                    <div class="row card-body">
                                        <div class="align-self-center setting_icon_div px-2">
                                            <img width="64" height="64" src="../assets/images/stylist_setting.svg">
                                        </div>
                                        <div class="content_div">
                                            <h5><b>Stylists</b></h5>
                                            <p class="m-0 ash font-14 content_text">Manage all your stylists details and their working hours.</p>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                            <a :href="this.url+'StaffWorkinghrs/'">
                                <div class="card mt-4">
                                    <div class="row card-body">
                                        <div class="align-self-center setting_icon_div px-2">
                                            <img width="64" height="64" src="../assets/images/salon_hour_setting.svg">
                                        </div>
                                        <div class="content_div">
                                            <h5><b>Stylist Hours</b></h5>
                                            <p class="m-0 ash font-14 content_text">Manage all your stylist's working hours as per weekly schedule and holidays.</p>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>

                </div>
            </div>

            <div class="row m-16">
                <div class="col-12 mt-4">
                    <h3 class="m-0">Advanced</h3>
                </div>
                <div class="col-12">
                    <div class="row">
                        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                            <a :href="this.url+'settings/paymentmode'">
                                <div class="card mt-4">
                                    <div class="row card-body">
                                        <div class="align-self-center setting_icon_div px-2">
                                            <img width="64" height="64" src="../assets/images/payment_setting.svg">
                                        </div>
                                        <div class="content_div">
                                            <h5><b>Payments</b></h5>
                                            <p class="m-0 ash font-14 content_text">Manage all of your different payment method details with the respective salon.</p>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                            <a :href="this.url+'settings/notification_settings'">
                                <div class="card mt-4">
                                    <div class="row card-body">
                                        <div class="align-self-center setting_icon_div px-2">
                                            <img width="64" height="64" src="../assets/images/notification_setting.svg">
                                        </div>
                                        <div class="content_div">
                                            <h5><b>Notifications</b></h5>
                                            <p class="m-0 ash font-14 content_text">Send Email and SMS reminders, booking confirmations, etc to your customers.</p>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                            <a :href="this.url+'settings/staff_service_mapping'">
                                <div class="card mt-4">
                                    <div class="row card-body">
                                        <div class="align-self-center setting_icon_div px-2">
                                            <img width="64" height="64" src="../assets/images/mapping_setting.svg">
                                        </div>
                                        <div class="content_div">
                                            <h5><b>Mapping</b></h5>
                                            <p class="m-0 ash font-14 content_text">Manage all of your service mappings with its stylists to the respective salon</p>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                            <a :href="this.url+'Stores_tracking/tracking_mode'">
                                <div class="card mt-4">
                                    <div class="row card-body">
                                        <div class="align-self-center setting_icon_div px-2">
                                            <img width="64" height="64" src="../assets/images/tracking_setting.svg">
                                        </div>
                                        <div class="content_div">
                                            <h5><b>Tracking</b></h5>
                                            <p class="m-0 ash font-14 content_text">Manage Google, Facebook, etc tracking details for your services, classes, and products.</p>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                            <a :href="this.url+'sharebooking'">
                                <div class="card mt-4">
                                    <div class="row card-body">
                                        <div class="align-self-center setting_icon_div px-2">
                                            <img width="64" height="64" src="../assets/images/share_link_setting.svg">
                                        </div>
                                        <div class="content_div">
                                            <h5><b>Share Links</b></h5>
                                            <p class="m-0 ash font-14 content_text">Manage booking and salon social links that help to engage your customers.</p>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                            <a :href="this.url+'stores_terms/store_terms_conditions'">
                                <div class="card mt-4">
                                    <div class="row card-body">
                                        <div class="align-self-center setting_icon_div px-2">
                                            <img width="64" height="64" src="../assets/images/terms_conditions.svg">
                                        </div>
                                        <div class="content_div">
                                            <h5><b>Terms & Conditions</b></h5>
                                            <p class="m-0 ash font-14 content_text">Manage salon terms and conditions for all the respective salons.</p>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>

                    </div>

                </div>
            </div>

         </div>
    </div>
</template>

<script>
export default {
    name: 'setting_component',
    data() {
      return {
        url:window.location.origin+'/index.php/',
      }
    },
}
</script>